export enum GetJobDataOperation {
	Default = 0,
	Zoom = 1,
	Shift = 2,
	ChangeInterval = 3
}
